import { timeUtil } from '@cmg/common';

import { ParticipationSetsGridColDef } from '../../types';

type Value = string | null | undefined;

export const pricingDateColDef: ParticipationSetsGridColDef<Value> = {
  headerName: 'Pricing Date',
  field: 'offering.pricingDate',
  type: ['date'],
  pinned: 'left',
  filter: false,
  width: 148,
  lockPinned: true,
  lockPosition: true,
  lockVisible: true,
  valueFormatter: ({ value }) => timeUtil.getDisplayValueForMonthDateYear(value),
};
